module.exports = __webpack_public_path__ + "img/hexagon-ring.9f4b66f6.svg";